import { api } from './base';

export const diagramExportApi = {
  /**
   * Export diagram to DXF, SVG, or PDF format
   */
  export: async (projectId: string, diagramId: string, format: 'dxf' | 'svg' | 'pdf', options?: Record<string, unknown>) => {
    const response = await api.post(`/projects/${projectId}/diagrams/${diagramId}/export`, {
      format,
      ...options,
    });
    return response.data.data;
  },
};
